import { Injectable } from "@angular/core";
import { StateManagerService } from "./state-manager.service";
import { environment } from "src/environments/environment";
import { GenerateWorkoutRequest, GenerateWorkoutResponse, SuccessResponse, CompleteExerciseRequest, CompleteExerciseResponse, GenerateFormRequest, GenerateFormResponse, AvailableModelsResponse } from "@me-fit-mono/typings";

@Injectable({
  providedIn: "root"
})
export class CopilotStateService {
  private API_AI_AGENTS = `${environment.API_ENDPOINT}/copilot`;

  /**
   * State for generating a workout using the AI agent
   */
  generateWorkout = this.$state.createState<GenerateWorkoutRequest, GenerateWorkoutResponse>({
    httpMethod: "post",
    path: `${this.API_AI_AGENTS}/workouts`,
  });

  /**
   * State for completing an exercise using the AI agent
   */
  completeExercise = this.$state.createState<CompleteExerciseRequest, CompleteExerciseResponse>({
    httpMethod: "post",
    path: `${this.API_AI_AGENTS}/exercise/complete`,
  });

  /**
   * State for generating a form/assessment using the AI agent
   */
  generateForm = this.$state.createState<GenerateFormRequest, GenerateFormResponse>({
    httpMethod: "post",
    path: `${this.API_AI_AGENTS}/forms`,
  });

  /**
   * State for getting available AI models
   */
  getAvailableModels = this.$state.createState<void, AvailableModelsResponse>({
    httpMethod: "get",
    path: `${this.API_AI_AGENTS}/models`,
  });

  constructor(private $state: StateManagerService) {}
}
